// A stand-in practitioner, for looking at the public form before the backend
// serves one.
//
// Reached only through `REACT_APP_FORMS_PREVIEW` — see `lib/site/config`. With
// that off, which is the default and every deployed build, nothing here is
// ever read and the screen fetches like any other.
//
// It exists because the endpoint behind this form does not yet: the backend
// plan issues each workspace a random id rather than the chosen name the link
// carries, so there is nothing live to point at. This lets the three screens be
// reviewed on a phone in the meantime.

import demoLogo from "../../../assets/svg/my brand/demo-logo.png";
import type { PublicEnquiryForm } from "../types/enquiries.types";

/**
 * Answers that make a preview submit fail, so the states that only a server
 * can produce are still reachable while there is no server.
 *
 * Use this email address to see what an enquiry the practitioner already holds
 * looks like — the message lands under the Email field. Any other address goes
 * through to the thank-you screen.
 */
export const PREVIEW_DUPLICATE_EMAIL = "used@test.com";

/** Ten digits that do the same for the phone field. */
export const PREVIEW_DUPLICATE_PHONE = "9999999999";

/**
 * The same specimen logo the brand previews use, so a form in preview looks
 * like one belonging to a practitioner who has uploaded artwork.
 */
export const PREVIEW_FORM: PublicEnquiryForm = {
  brand: {
    name: "Nutritionist Logo",
    logoUrl: demoLogo,
  },
  // Short lists rather than the catalog's real ones: this is here to show the
  // control, not to stand in for the backend's vocabulary. The goals carry
  // made-up `public_id`s, because a real form is served the practice's
  // services and each is picked by one.
  goals: [
    { id: "preview-goal-1", name: "Weight loss" },
    { id: "preview-goal-2", name: "Weight gain" },
    { id: "preview-goal-3", name: "Muscle building" },
    { id: "preview-goal-4", name: "Diabetes management" },
    { id: "preview-goal-5", name: "PCOS / hormonal health" },
    { id: "preview-goal-6", name: "General wellness" },
  ],
  lifeStyles: [
    { id: 8, name: "Sedentary", definition: "Mostly sitting/lying, minimal movement" },
    { id: 3, name: "Semi active", definition: "Moderate daily movement" },
    { id: 1, name: "Active", definition: "Regular exercise or physically active routine" },
    { id: 4, name: "Very active", definition: "Frequent/intense exercise" },
  ],
};
